function modelTransformer (data, request) {
    if (!request.success) {
        return null;
    }
    const Model = this.model;
    const json = data.json;

    if (Model) {
        return new Model(json, request.params);
    } else {
        return json;
    }
};

export default modelTransformer;
